import React from 'react'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import IconButton from '@material-ui/core/IconButton'
import EditIcon from '@material-ui/icons/Edit'
import FitnessCenterIcon from '@material-ui/icons/FitnessCenter'
import MyTableRow from '../../common/TableRow'
import MyTableCell from '../../common/CustomTableCell'
import DeleteIcon from '@material-ui/icons/Delete'

const headers = require('../../../assets/files/headers.json').VehicleClasses

const crudColors = require('../../../assets/files/env.json').theme.colors.crud
const StyledTableCell = withStyles((theme) => ({
	head: {
		backgroundColor: theme.palette.common.black,
		color: theme.palette.common.white,
	},
	body: {
		fontSize: 14,
	},
}))(TableCell)

const StyledTableRow = withStyles((theme) => ({
	root: {
		'&:nth-of-type(odd)': {
			backgroundColor: theme.palette.action.hover,
		},
		borderBottom: '2px solid #c4ddec',
	},
}))(TableRow)

const useStyles = makeStyles({
	table: {
		minWidth: 700,
	},
})

function CustomizedTables(props) {
	const classes = useStyles()
	let numbering = 0
	let prop = props
	return (
		<TableContainer component={Paper}>
			<Table
				size="small"
				className={classes.table}
				aria-label="customized table"
			>
				<TableHead>
					<MyTableRow header={headers}></MyTableRow>
				</TableHead>
				<TableBody>
					{props?.data?.map(function (item, index) {
						numbering++
						return (
							<StyledTableRow key={index}>
								<MyTableCell
									key={'vehicleClass_numbering' + index}
									value={item?.id}
									style={{
										width: '10%',
									}}
								></MyTableCell>

								<MyTableCell
									key={'vehicleClass_name' + item.id}
									value={item.name}
									style={{
										width: '30%',
									}}
								></MyTableCell>
								<MyTableCell
									key={'vehicleClass_description' + item.id}
									value={item?.descr}
									style={{
										width: '30%',
									}}
								></MyTableCell>
								<MyTableCell
									key={'vehicleClass_note_thatee' + item.id}
									value={item?.note_thatee}
									style={{
										width: '30%',
									}}
								></MyTableCell>
								<MyTableCell
									key={'vehicleClass_note_moajar' + item.id}
									value={item?.note_moajar}
									style={{
										width: '30%',
									}}
								></MyTableCell>
								<MyTableCell
									key={'vehicleClass_is_in' + item.id}
									value={item?.is_in ? "نعم" : "كلا"}
									style={{
										width: '50%',
									}}
								></MyTableCell>
								<MyTableCell
									key={'vehicleClass_is_out' + item.id}
									value={item?.is_out ? "نعم" : "كلا"}
									style={{
										width: '50%',
									}}
								></MyTableCell>
								<MyTableCell
									key={'vehicleClass_station' + item.id}
									value={item?.station?.caption}
									style={{
										width: '50%',
									}}
								></MyTableCell>
								<StyledTableCell
									key={'center_weights' + item.id}
									align="right"
									style={{
										width: '60px',
									}}
								>
									<IconButton
										title="تغيير الاوزان"
										onClick={() =>
											prop.showChangeWeightsModalFun({
												vehicleClass: item,
												index: index,
											})
										}
									>
										<FitnessCenterIcon style={{ color: '#FF9800' }} />
									</IconButton>
								</StyledTableCell>
								<StyledTableCell
									key={'center_edit' + item.id}
									align="right"
									style={{
										width: '60px',
									}}
								>
									<IconButton
										onClick={() =>
											prop.showEditModalFun({
												vehicleClass: item,
												index: index,
											})
										}
									>
										<EditIcon style={{ color: crudColors.u }} />
									</IconButton>
								</StyledTableCell>
								{item?.id && item?.id > 14 ? (
									<StyledTableCell
										key={'center_delete' + item.id}
										align="right"
										style={{
											width: '60px',
										}}
									>
										<IconButton
											onClick={() =>
												prop.showDeleteModalFun({
													vehicleClass: item,
													index: index,
												})
											}
										>
											<DeleteIcon style={{ color: crudColors.d }} />
										</IconButton>
									</StyledTableCell>
								) : (
									<StyledTableCell
										key={'center_delete' + item.id}
										align="right"
										style={{
											width: '60px',
										}}
									></StyledTableCell>
								)}
							</StyledTableRow>
						)
					})}
				</TableBody>
			</Table>
		</TableContainer>
	)
}

export default CustomizedTables
